import type { ButtonProps } from '@mui/material/Button';
import type { Theme, SxProps } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { GQLMutation } from '@/lib/client';
import { USER_LOGOUT } from '@/lib/mutations/user.mutation';
import { AgentCheckIn } from '@/lib/services/agent-check-in';
import { clearPersistedWorkspace } from '@/contexts/workspace-context';



type Props = ButtonProps & {
  sx?: SxProps<Theme>;
  onClose?: () => void;
};

export function SignOutButton({ onClose, ...other }: Props) {
  const { action: signout, loading: signingOut } = GQLMutation({
    mutation: USER_LOGOUT,
    resolver: 'logout',
    toastmsg: true,
    callback: () => {
      AgentCheckIn.reset();
      clearPersistedWorkspace();
      window.location.replace('/');
    },
  })

  const handleSignOut = () => signout()

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      disabled={signingOut}
      onClick={handleSignOut}
      {...other}
    >
      {signingOut ? 'Signing Out...' : 'Sign Out'}
    </Button>
  );
}
